import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as appActions from './actions/app-actions';
import RemixPlayer from './RemixPlayer';
import SamPlayer from './SamPlayer';
import History from './History';

import './App.css';

class App extends Component {

  componentWillMount(){
    this.props.appActions.getPlayerData();
  }

  // load the correct player
  loadPlayer(){
    let isRemix = this.props.player.remix;
    // make sure we are not null, and is remix
    if(isRemix === true && isRemix !== null){
      return <RemixPlayer />;
    }

    if(isRemix === false && isRemix !== null){
      return <SamPlayer />;
    }
  }

  render() {
    return (
      <div className="App">

        <div className="Content container-fluid">
          { this.loadPlayer() }
          <History />
        </div>

      </div>
    );
  }
}

function mapStateToProps(state){
    return {
        player: state.app.player.toJS()
    };
}

function mapDispatchToProps(dispatch){
    return {
        appActions: bindActionCreators(appActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/App.js